import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const snapButtons = () => {
	let buttons = gsap.utils.toArray('.wp-block-rb-snap-buttons.animate .wp-block-rb-snap-buttons__button');

	if ( buttons.length < 1 ) {
		return;
	}

	buttons = gsap.utils.shuffle(buttons);

	const timeline = gsap.timeline({
		paused: true,
		scrollTrigger: {
			trigger: '.wp-block-rb-snap-buttons',
			start: 'top bottom',
			end: 'bottom top',
			toggleActions: 'play none none play',
			onEnter: () => {
				timeline.resume();
			},
			onEnterBack: () => {
				timeline.resume();
			},
			onLeave: () => {
				timeline.pause();
			},
			onLeaveBack: () => {
				timeline.pause();
			}
		}
	})


	timeline.to( buttons, {
		duration: 1,
		y: -250,
		zIndex: 10,
		"--shadow-distance": '110px',
		'--shadow-blur': '70px',
		'--shadow-color': 'rgba(0,51,153,0.2)',
		stagger: {
			repeat: 1,
			yoyo: true,
			amount: 30,
			ease: 'linear',
		},
		repeat: -1,
		ease: 'power2',
	})
}

window.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		snapButtons();
	}, 5000 );
})